"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
class Format {
    static setUserName(email) {
        if (_.isNil(email) || email == "")
            return email;
        const userName = email.split('@')[0].split('.');
        return Format.capitalizeFirstLetter(userName[0]) + " " + Format.capitalizeFirstLetter(userName[1]);
    }
    static capitalizeFirstLetter(text) {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
}
exports.Format = Format;
//# sourceMappingURL=format.js.map